import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/page/home/home'
import Index from '@/page/index/Index'
// import AdminLogin from '@/page/login/AdminLogin'
import Login from '@/page/login/Login'
import Register from '@/page/login/Register'
import SelectIdentity from '@/page/login/SelectIdentity'
import StuIndex from '@/page/stuSystem/StuSystemIndex'
import TeaIndex from '@/page/teaSystem/TeaSystemIndex'
import AssistantSystemIndex from '../page/assistantSystem/AssistantSystemIndex'
import AdminManager from '@/page/userManager/AdminManager'
import TeaManager from '@/page/userManager/TeaManager'
import TeacherInfo from '@/page/userManager/TeacherInfo'
import AssistantManager from '@/page/userManager/AssistantManager'
import StuManager from '@/page/userManager/StuManager'
import StudentInfo from '@/page/userManager/StudentInfo'
import CourseManager from '@/page/courseManager/CourseManager'
import LiveManager from '@/page/courseManager/LiveManager'
import CourseLiveManager from '@/page/courseManager/CourseLiveManager'
import SubLiveClassManager from '@/page/courseManager/SubLiveClassManager'
import CloudDisk from '@/page/cloudDisk/CloudDisk'
import ReadGroupCloudDisk from '../page/cloudDisk/ReadGroupCloudDisk'
import AdminMessage from '../page/adminMessage/AdminMessage'
import TestPage from '@/page/test/TestPage'
import TestCorpper from '@/page/test/TestCorpper'

import Recharge from '@/page/financedManager/Recharge'
import RechargeRecord from '@/page/financedManager/RechargeRecord'
import CostRecord from '@/page/financedManager/CostRecord'
import PayResult from '@/page/financedManager/PayResult'

import LiveCalendar from '@/page/live/LiveCalendar'
import Courses from '@/page/live/Courses'
import StuLiveRoom from '@/page/stuSystem/StuLiveRoom'
import AssistantLiveRoom from '../page/assistantSystem/AssistantLiveRoom'
import Message from '../page/live/Message'
import UserInfo from '../page/live/UserInfo'
import PlaybackRoom from '../page/playback/PlaybackRoom'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/identity',
      name: 'SelectIdentity',
      component: SelectIdentity
    },
    {
      path: '/assistantIndex',
      name: 'assistantIndex',
      component: AssistantSystemIndex,
      children: [{
        path: '',
        component: LiveCalendar
      },
      {
        path: 'courses',
        component: Courses
      },
      {
        path: 'message',
        component: Message
      },
      {
        path: 'userinfo',
        component: UserInfo
      }]
    },
    {
      path: '/stuIndex',
      name: 'StuIndex',
      component: StuIndex,
      children: [{
        path: '',
        component: LiveCalendar
      },
      {
        path: 'courses',
        component: Courses
      },
      {
        path: 'message',
        component: Message
      },
      {
        path: 'userinfo',
        component: UserInfo
      }]
    },
    {
      path: '/teaIndex',
      name: 'TeaIndex',
      component: TeaIndex,
      children: [{
        path: '',
        component: LiveCalendar
      },
      {
        path: 'courses',
        component: Courses
      },
      {
        path: 'clouddiskop',
        component: ReadGroupCloudDisk
      },
      {
        path: 'teaclouddiskop',
        component: CloudDisk
      },
      {
        path: 'message',
        component: Message
      },
      {
        path: 'userinfo',
        component: UserInfo
      }]
    },
    {
      path: '/testpage',
      name: 'TestPage',
      component: TestPage
    },
    {
      path: '/testcorpper',
      name: 'TestCorpper',
      component: TestCorpper
    },
    {
      path: '/',
      name: '',
      component: Index,
      children: [{
        path: '',
        component: Home,
        meta: []
      },
      {
        path: '/adminop',
        component: AdminManager,
        meta: []
      },
      {
        path: '/teacherop',
        component: TeaManager,
        meta: []
      },
      {
        path: '/assistantop',
        component: AssistantManager,
        meta: []
      },
      {
        path: '/studentop',
        component: StuManager,
        meta: []
      },
      {
        path: '/courseop',
        component: CourseManager,
        meta: []
      },
      {
        path: '/liveop',
        component: LiveManager,
        meta: []
      },
      {
        path: '/liveCourse',
        name: 'liveCourse',
        component: CourseLiveManager,
        meta: []
      },
      {
        path: '/subLiveManager',
        name: 'subLiveManager',
        component: SubLiveClassManager,
        meta: []
      },
      {
        path: '/teacherInfo',
        name: 'teacherInfo',
        component: TeacherInfo,
        meta: []
      },
      {
        path: '/clouddiskop',
        name: 'cloudDisk',
        component: CloudDisk,
        meta: []
      },
      {
        path: '/studentInfo',
        name: 'studentInfo',
        component: StudentInfo,
        meta: []
      },
      {
        path: '/recharge',
        component: Recharge,
        meta: []
      },
      {
        path: '/rechargerecord',
        component: RechargeRecord,
        meta: []
      },
      {
        path: '/costrecord',
        component: CostRecord,
        meta: []
      },
      {
        path: '/messageop',
        component: AdminMessage,
        meta: []
      }]
    },
    {
      path: '/stuLiveRoom',
      name: 'stuLiveRoom',
      component: StuLiveRoom
    },
    {
      path: '/assistantLiveRoom',
      name: 'AssistantLiveRoom',
      component: AssistantLiveRoom
    },
    {
      path: '/playbackRoom',
      name: 'PlaybackRoom',
      component: PlaybackRoom

    },
    {
      path: '/payresult',
      name: 'PayResult',
      component: PayResult
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js